var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path10, _path11;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgHongkong = function SvgHongkong(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.712 21.75c5.523 0 10-4.477 10-10s-4.477-10-10-10c-5.522 0-10 4.477-10 10s4.478 10 10 10Z",
    fill: "#ED4C5C"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.046 10.35c.233-.6.8-.7 1.1-1.467.133-.333-.1-1 .033-1.333.3-.767 1.067-.633 1.067-.633-1.367-.5-2.9.2-3.4 1.533s.2 2.833 1.566 3.3c-.366-.4-.566-.867-.366-1.4Z",
    fill: "#fff"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.18 8.483a.3.3 0 1 0 0-.6.3.3 0 0 0 0 .6Z",
    fill: "#ED4C5C"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M9.913 11.683c-.5-.4-.434-.966-1.1-1.466-.3-.234-1-.2-1.3-.434-.667-.5-.267-1.2-.267-1.2-.9 1.134-.7 2.767.467 3.634 1.133.866 2.8.666 3.7-.434-.534.2-1.034.234-1.5-.1Z",
    fill: "#fff"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M8.012 11.217a.3.3 0 1 0 0-.6.3.3 0 0 0 0 .6Z",
    fill: "#ED4C5C"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M10.879 13.15c-.533.367-1.067.1-1.767.567-.3.2-.5.866-.8 1.066-.7.467-1.266-.1-1.266-.1.8 1.2 2.466 1.5 3.666.7 1.2-.8 1.534-2.4.734-3.6.033.567-.1 1.034-.567 1.367Z",
    fill: "#fff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M9.412 14.517c.1-.134.3-.167.434-.067.133.1.166.3.066.433-.1.134-.3.167-.433.067a.316.316 0 0 1-.067-.433Z",
    fill: "#ED4C5C"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M12.58 12.717c.166.6-.234 1.033 0 1.833.1.333.666.733.766 1.1.233.8-.5 1.133-.5 1.133 1.4-.4 2.2-1.833 1.8-3.2-.4-1.366-1.867-2.166-3.267-1.766.6.1 1.034.333 1.2.9Z",
    fill: "#fff"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M13.613 14.483a.316.316 0 0 1 .066-.433.316.316 0 0 1 .434.067c.1.133.066.333-.067.433-.167.133-.333.1-.433-.067Z",
    fill: "#ED4C5C"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M12.68 10.983c.666.034.933.534 1.766.567.367 0 .933-.4 1.3-.4.833.033.933.8.933.8.067-1.433-1.1-2.633-2.533-2.667-1.467-.033-2.667 1.067-2.733 2.5.3-.5.7-.833 1.266-.8Z",
    fill: "#fff"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    d: "M14.88 10.583c-.168.067-.334-.033-.4-.2-.068-.166.032-.333.2-.4.166-.066.332.034.4.2.066.167-.034.367-.2.4Z",
    fill: "#ED4C5C"
  })));
};
export default SvgHongkong;